export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/11a14d9b63ec892bb84cea8c67204259.svg";